import { ReactComponent as CheckedBlueBoxIcon } from './checked-box-blue.svg'
export default CheckedBlueBoxIcon
